const menuController = Router.getController('customer.account.menuController');

$(() => {
  const notificationsTable = $('#notifications-table').DataTable({
    processing: false,
    serverSide: true,
    ajax: urlNotificationsData,
    pageLength: 10,
    bFilter: true,
    lengthChange: false,
    searching: false,
    info: false,
    pagingType: 'simple',
    autoWidth: false,
    columns: [
      { data: 'content' },
    ]
  });

  menuController.el.on('tab-activated', (el, tab) => {
    if (tab === 'notifications') {
      notificationsTable.ajax.reload(null, false);
    }
  });

  $('.notifications-dropdown').on('update', () => {
    if (menuController.getCurrentTab() === 'notifications') {
      notificationsTable.ajax.reload(null, false);
    }
  });
});
